// eslint-disable-next-line import/no-unresolved
import { Unsubscribe } from '@superbet-group/web.lib.feature-toggle-service/dist/types';
import { featureFlagService } from '@superbet-group/web.lib.flags';
import { Dispatch } from 'vuex';

import { AccountFlagNames } from '@app/modules/userProfile/account/FeatureFlags';

// eslint-disable-next-line require-await
export async function loadAccountFeatureToggleSubscriptions({ dispatch }: { dispatch: Dispatch }): Promise<Unsubscribe> {
    return featureFlagService.subscribeToFeatureChanges(AccountFlagNames.isMultiStepIdVerification, (isMultiStepIdVerification) => {
        dispatch('ui/multiStepVerification/initializeIdCardVerification', isMultiStepIdVerification);
    }, false);
}
